module.exports = __webpack_public_path__ + "static/media/atencion-personalizada.82e4ab8e.svg";